<template>
  <div class="app-container">
    <div>
      <!-- <div class="detailsTitle">
        <h4>结算单</h4>
      </div> -->
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" ref="formData" label-width="90px" size="mini">
          <el-form-item label="一级货主:">
            <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据状态:">
            <el-select v-model="formData.status" size="mini" placeholder="请选择单据状态" filterable clearable>
              <el-option v-for="(item, index) in daJuStatusData" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:">
            <el-date-picker v-model="formData.createDate" size="mini" type="date" placeholder="请选择"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="结算单编号:">
            <el-input class="ipt" v-model="formData.settleNo" maxlength="50" placeholder="请输入结算单编号" size="mini">
            </el-input>
          </el-form-item>
          <br />
          <el-form-item style="margin-top:5px;">
            <el-button type="primary" @click="chaXun" size="mini" btnCode="003P01rB001" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" @click="chongZhi" size="mini" btnCode="003P01rB002" v-if="btnFlg[1]">重置
            </el-button>
            <el-button type="primary" @click="xinzeng" size="mini" btnCode="003P01rB003" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" @click="shouFei" size="mini" btnCode="003P01rB004" v-if="btnFlg[3]">收费</el-button>
            <el-button type="primary" @click="zuoFei" size="mini" btnCode="003P01rB005" v-if="btnFlg[4]">作废</el-button>
            <el-button type="primary" @click="daoChu" size="mini" btnCode="003P01rB006" v-if="btnFlg[5]">导出</el-button>
            <el-button type="primary" @click="daoChuYZD" size="mini" v-if="btnFlg[6]">导出月账单</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="height:10px;"></div>
      <div style="width:99%;text-align: right;margin-top:-35px;overflow: hidden;">
        <a class="xieyi" target="_blank"
          href="https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/wms/wordModel/%E7%BB%93%E7%AE%97%E8%AE%A1%E7%AE%97%E6%A0%87%E5%87%86-20220225.docx">下载结算计算标准</a>
      </div>
      <div class="tableClass" :style="{ height: h}" style="margin-top:10px;">
        <el-table ref="table" size="mini" :data="tableData" highlight-current-row
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="dianjixuanzhong" height="100%"
          style="width:100%" border center bordersize="mini">
          <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
          <el-table-column label="操作" width="60">
            <template v-slot="scoped">
              <el-button v-if="scoped.row.status != '已作废'" type="text" @click="tableDaochu(scoped.row)" size="mini">导出
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="settleNo" label="结算单编号" align="center" width="200">
            <template v-slot="scope">
              <el-button type="text" @click="SettlementNo(scope.row)" size="mini">{{scope.row.settleNo}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="单据状态" align="center" width="100">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.status == '待结算'">待结算</span>
                <span v-if="scope.row.status == '已结算'" style="color:green;">已结算</span>
                <span v-if="scope.row.status == '已作废'" style="color:red;">已作废</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="230"></el-table-column>
          <el-table-column prop="customerName" label="二级货主" align="center" width="230"></el-table-column>
          <el-table-column prop="planCharge" label="应收金额(元)" align="center" width="110"></el-table-column>
          <el-table-column prop="actualCharge" label="实收金额(元)" align="center" width="110"></el-table-column>
          <el-table-column prop="settleStartTime" label="结算开始时间" align="center" width="180" :formatter="dateFormat">
          </el-table-column>
          <el-table-column prop="settleEndTime" label="结算结束时间" align="center" width="180" :formatter="dateFormat">
          </el-table-column>
          <el-table-column prop="createUser" label="创建人" align="center" width="120"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="180" :formatter="dateTimeFormat">
          </el-table-column>
        </el-table>
      </div>
      <div class="pags" style="text-align: left">
        <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="formData.pageNo"
          :page-size="formData.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
        </el-pagination>
      </div>
    </div>
    <div class="JZfangshi inpBox">
      <el-dialog :title="JZTitle" :visible.sync="XZVisible" :close-on-click-modal="false" width="720px" center
        @close="closeJZDialog">
        <el-form :model="addFormData" :inline="true" ref="addFormData" label-width="130px" :rules="rulesXz"
          size="small">
          <el-form-item prop="primaryCustomerId" label="一级货主">
            <el-select v-model="addFormData.primaryCustomerId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="secondaryCustomerId" label="二级货主">
            <el-select v-model="addFormData.secondaryCustomerId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="settleStartTime" label="结算时间从(含)">
            <el-date-picker v-model="addFormData.settleStartTime" size="mini" type="date" placeholder="请选择"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item prop="settleEndTime" label="到(含)">
            <el-date-picker v-model="addFormData.settleEndTime" size="mini" type="date" placeholder="请选择"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item prop="settleTypeList" label="结算费目">
            <el-checkbox-group v-model="addFormData.settleTypeList">
              <el-checkbox v-for="item in checkedDataList" :key="item.feeName" :label="item.feeName">{{ item.feeName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div style="font-size:13px;color:red;margin-left:140px;">
            <span>提示：</span>
            <span>装卸费请按照时间先后顺序结算</span>
          </div>
        </el-form>
        <div style="width: 140px; margin: 15px auto">
          <el-button size="mini" @click="closeJZDialog">取消</el-button>
          <el-button size="mini" type="primary" @click="addJZDialog" :loading="JZLoading">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="收费" :visible.sync="SFVisible" :close-on-click-modal="false" width="500px" center
        @close="closeSFDialog">
        <el-form :model="SFData" ref="SFData" label-width="130px" size="small">
          <el-form-item prop="yingShou" label="应收费用">
            <span style="color:red;">{{SFData.yingShou}}</span>
          </el-form-item>
          <el-form-item prop="shiShou" label="实收费用" :rules="[{
          required: true,
          message: '请输入实收费用',
          trigger: 'blur',
        }]">
            <el-input size="mini" v-number-input.float='2' v-model="SFData.shiShou" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div style="width: 150px; margin: 20px auto">
          <el-button size="mini" @click="closeSFDialog">取消</el-button>
          <el-button size="mini" type="primary" @click="SFSubmit" :loading="SFLoading">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="作废" :visible.sync="ZFVisible" :close-on-click-modal="false" width="500px" center
        @close="closeZFDialog">
        <el-form :model="ZFData" ref="ZFData" label-width="130px">
          <el-form-item prop="ZFreason" label="作废原因" :rules="[{
          required: true,
          message: '请输入作废原因',
          trigger: 'blur',
        }]">
            <el-input type="textarea" v-model="ZFData.ZFreason" maxlength="100" :rows="2" style="width:200px;">
            </el-input>
          </el-form-item>
        </el-form>
        <div style="width: 140px; margin: 20px auto">
          <el-button @click="closeZFDialog" size="mini">取消</el-button>
          <el-button type="primary" size="mini" @click="ZFSubmit" :loading="ZFLoading">保存</el-button>
        </div>
      </el-dialog>
    </div>
    <daochu-month v-if="MonthVisible" :MonthVisible.sync="MonthVisible"></daochu-month>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  generatorChargeInfo,
  getSettlementInfoList,
  doCharge,
  cancelSettlementInfo
} from '@/api/wms-stock'
import {
  getSheetListBySysModelForWms
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
import {
  getBtn
} from '@/utils/getButton'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  dateTimeFormat,
  dateFormat
} from '@/utils/util'
import daochuMonth from './daochuMonth.vue'
export default {
  components: {
    daochuMonth
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      JZLoading: false,
      btnArr: [
        '003P01rB001',
        '003P01rB002',
        '003P01rB003',
        '003P01rB004',
        '003P01rB005',
        '003P01rB006',
        '003M3E0100'
      ],
      btnFlg: [],
      h: '400px',
      formData: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        status: '',
        createDate: '',
        settleNo: '',
        pageNo: 1,
        pageSize: 20
      },
      RKData: [],
      daJuStatusData: [{
        'label': '待结算',
        'value': '0'
      },
      {
        'label': '已结算',
        'value': '1'
      },
      {
        'label': '已作废',
        'value': '2'
      }
      ],
      tableData: [],
      JZTitle: '',
      XZVisible: false,
      addFormData: {
        primaryCustomerId: '',
        secondaryCustomerId: '',
        primaryCustomerName: '',
        secondaryCustomerName: '',
        settleStartTime: '',
        settleEndTime: '',
        settleTypeList: []
      },
      checkedDataList: [],
      rulesXz: {
        primaryCustomerId: [{
          required: true,
          message: '请选择一级货主',
          trigger: 'change'
        }],
        secondaryCustomerId: [{
          required: true,
          message: '请选择二级货主',
          trigger: 'change'
        }],
        settleStartTime: [{
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        settleEndTime: [{
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        settleTypeList: [{
          type: 'array',
          required: true,
          message: '请至少选择一个结算费目',
          trigger: 'change'
        }]
      },
      totalXQ: 0,
      xuanzhongArr: null,
      messages: '添加成功',
      SFVisible: false,
      SFData: {
        yingShou: '1',
        shiShou: ''
      },
      SFLoading: false,
      ZFVisible: false,
      ZFData: {
        ZFreason: ''
      },
      ZFLoading: false,
      settleInfoId: '',
      MonthVisible: false
    }
  },
  methods: {
    tableDaochu (row) {
      exportExcel(
        this.global.wmsStockName + '/tEmptyForJanFaCharge/exportJcYycFeeList', {
          settleInfoId: row.settleInfoId
        },
        '对账单表'
      )
    },
    daoChuYZD () {
      this.MonthVisible = true
    },
    SettlementNo (row) {
      this.$router.push({
        path: '/feeSettlementDetails', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          settleInfoId: row.settleInfoId
        }
      })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    initForm () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.status = ''
      this.formData.createDate = ''
      this.formData.settleNo = ''
      this.formData.pageNo = 1
      this.formData.pageSize = 20
      this.xuanzhongArr = null
      this.getSettlementInfoList()
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    // 列表查询
    getSettlementInfoList () {
      getSettlementInfoList(this.formData).then((res) => {
        this.tableData = res.list
        this.totalXQ = res.total
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    chaXun () {
      this.getSettlementInfoList()
    },
    chongZhi () {
      this.initForm()
    },
    // 新增弹框获取结算费目
    getSheetListBySysModelForWms () {
      getSheetListBySysModelForWms({
        sysModel: '2',
        tenantCode: localStorage.getItem('tenantCode'),
        ext1: '1'
      }).then((res) => {
        this.checkedDataList = res
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    xinzeng () {
      this.XZVisible = true
      this.JZTitle = '新增'
      // this.addFormData.productType = ''
      // this.addFormData.inWeighingMethod = ''
      // this.addFormData.inPoundMethod = ''
      // this.addFormData.outWeighingMethod = ''
      // this.addFormData.outPoundMethod = ''
      // this.addFormData.weighingMethodId = ''
      this.$nextTick(() => {
        this.$refs.addFormData.clearValidate()
      })
      this.getSheetListBySysModelForWms()
    },
    zuoFei () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.status != '待结算') {
        DonMessage.error('只能作废待结算状态的数据')
      } else {
        this.ZFVisible = true
      }
    },
    closeZFDialog () {
      this.ZFVisible = false
      this.$refs.ZFData.resetFields()
    },
    ZFSubmit () {
      this.$refs.ZFData.validate((valid) => {
        if (valid) {
          this.ZFLoading = true
          cancelSettlementInfo({
            settleInfoId: this.xuanzhongArr.settleInfoId,
            cancellationReason: this.ZFData.ZFreason
          }).then((res) => {
            this.ZFLoading = false
            DonMessage.success('成功')
            this.ZFVisible = false
            this.getSettlementInfoList()
          })
            .catch((err) => {
              this.ZFLoading = false
              DonMessage.error(err.message)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    shouFei () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.status != '待结算') {
        DonMessage.error('只能操作待结算状态的数据')
      } else {
        this.SFVisible = true
        this.SFData.yingShou = this.xuanzhongArr.planCharge
        if (this.xuanzhongArr.actualCharge) {
          this.SFData.shiShou = this.xuanzhongArr.actualCharge
        } else {
          this.SFData.shiShou = this.xuanzhongArr.planCharge
        }
      }
    },
    SFSubmit () {
      this.$refs.SFData.validate((valid) => {
        if (valid) {
          this.SFLoading = true
          doCharge({
            settleInfoId: this.xuanzhongArr.settleInfoId,
            actualCharge: this.SFData.shiShou
          }).then((res) => {
            this.SFLoading = false
            DonMessage.success('成功')
            this.SFVisible = false
            this.getSettlementInfoList()
          })
            .catch((err) => {
              this.SFLoading = false
              DonMessage.error(err.message)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeSFDialog () {
      this.SFVisible = false
      this.$refs.SFData.resetFields()
      this.SFData.yingShou = ''
      this.SFData.shiShou = ''
    },
    daoChu () {
      exportExcel(
        this.global.wmsStockName + '/tEmptyForJanFaCharge/exportSettlementInfoList', {
          ...this.formData
        },
        '结算单表'
      )
    },
    generatorChargeInfo () {
      this.addFormData.primaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.addFormData
        .primaryCustomerId)[0].custerName
      this.addFormData.secondaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.addFormData
        .secondaryCustomerId)[0].custerName
      this.JZLoading = true
      generatorChargeInfo(this.addFormData).then((res) => {
        this.JZLoading = false
        DonMessage.success('成功')
        this.XZVisible = false
        this.getSettlementInfoList()
      })
        .catch((err) => {
          this.JZLoading = false
          DonMessage.error(err.message)
        })
    },
    addJZDialog () {
      this.$refs.addFormData.validate((valid) => {
        if (valid) {
          this.generatorChargeInfo()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeJZDialog () {
      this.XZVisible = false
      this.$refs.addFormData.resetFields()
    },
    handleCurrentChangeXQ (val) {
      this.formData.pageNo = val
      this.getSettlementInfoList()
    },
    handleSizeChangeXQ (val) {
      this.formData.pageSize = val
      this.getSettlementInfoList()
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/feeSettlement')
    this.getRelationCustomerS()
    this.getSettlementInfoList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaXun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 170 + 'px'
  }

}

</script>

<style lang="less" scoped>
  .tableClass {
    max-height: calc(100vh - 200px);
    overflow: auto;
  }

  .inpBox {
    .el-form-item {
      margin-left: 10px;
      // margin-bottom: 22px;
    }

    /deep/.el-input__inner {
      width: 170px !important;
    }
  }

  .xieyi {
    color: #409eff;
    cursor: pointer;
    text-decoration: none;
    margin-top: -10px;
    font-size: 12px;
  }

</style>
